const scheduledServicesStore = {
  scheduledServiceCreated: 'Serviço agendado criado com sucesso',
  scheduledServicesCreated: 'Serviços agendados criados com sucesso',
  scheduledServiceDeleted: 'Serviço agendado deletado com sucesso',
  scheduledServiceUpdated: 'Serviço agendado atualizado com sucesso',
};

export default scheduledServicesStore;
